// @flow
import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";

const style = () => ({
    suggestionsTitle: {
        paddingLeft: 8,
    },
});

type SearchSuggestionsMenuStyleClasses = {
    suggestionsTitle: string,
};

type Props = {
    suggestions: Array<any>,
    onSuggestionClick: Function,
    classes: SearchSuggestionsMenuStyleClasses,
}

const SearchSuggestionsMenu = (props: Props) => {
    const renderSuggestion = (suggestion) => (
        <ListItem
            key={suggestion.id}
            button
            onClick={() => props.onSuggestionClick(suggestion.id)}
        >
            <ListItemText>
                {suggestion.searchText}
            </ListItemText>
        </ListItem>
    );

    return (
        props.suggestions.length > 0 &&
        <div>
            <Divider />
            <List>
                <Typography variant="caption" className={props.classes.suggestionsTitle}>
                    Suggestions:
                </Typography>
                {props.suggestions.map(renderSuggestion)}
            </List>
        </div>
    );
};

export default withStyles(style)(SearchSuggestionsMenu);
